import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './Pages/Home'
import Contact from './Pages/Contact'
import About from './components/About'
import Experience from './components/Experience'
import Skills from './components/Skills'
import Project from './Pages/Project'
const App = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/#about' element={<About />} />
      <Route path='/#skill' element={<Skills />} />
      <Route path='/#experience' element={<Experience />} />
      <Route path='/project' element={<Project />} />
    </Routes>
  )
}

export default App
